// extracted by mini-css-extract-plugin
export default {"navigationItemWrapper":"styles_navigationItemWrapper__N1jAL","borderBtm":"styles_borderBtm__mDye1","contentWrapper":"styles_contentWrapper__WcMiE"};